import React from 'react'
import { Card as CardAnt } from 'antd'
import { CardProps } from 'antd/lib/card'

import { useT } from 'src/core/hooks/use-translation'

function Card({ title, children, ...props }: CardProps) {
  const { t } = useT()

  return (
    <CardAnt title={typeof title === 'string' ? t(title) : title} {...props}>
      {children}
    </CardAnt>
  )
}

export default Card
